<template>
    <tr>
        <td class="no_padding drag_drop"><span></span></td>
        <td :data-th="'Odběratel' | translate" class="first_data pointer"><a @click="goToSubscriberDetail(entity.idSubscriber)"><strong>{{ entity.subscriberName }}</strong></a></td>
        <td :data-th="'Zařízení' | translate">
           <span class="dotted" @click.stop="showModal">
                {{ entity.recipients_devices_read }} / {{ entity.recipients_devices_total}}
            </span></td>
        <td :data-th="'Označeno za smazané' | translate" v-html="$_date_formatFull(entity.timestamp_deleted)"></td>
        <td class="no_padding edit"></td>
    </tr>
</template>

<script>
	import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "AdvertisingBannerRow",
		mixins: [rowActions],
    props:{
      idAdvertisingBanner: Number,
    },
		data() {
			return {
				moduleName: 'AdvertisingBanners',
			}
		},
    methods: {
      goToSubscriberDetail(id) {
        this.$router.push({name: 'subscriberDetail', params: {id: id}})
      },
      showModal() {
        this.$emit('showModal', this.entity)
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Detail/RecipientsRow.vue